<template>
  <Navbar />
  <div class="hidden lg:block container mt-5">
    <div class="page-banner1">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-md-6">
          <nav aria-label="Breadcrumb">
            <ul class="breadcrumb justify-content-center py-0 bg-transparent">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active">AN&Digit</li>
            </ul>
          </nav>
          <h1 class="text-center">Personal Projects</h1>
        </div>
      </div>
    </div>
  </div>
  <WorkAN />
  <Footer />
</template>

<script>
import WorkAN from "@/components/WorkAN.vue";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Andigit",
  data() {
    return {};
  },

  components: {
    WorkAN,
    Navbar,
    Footer,
  },
};
</script>

<style></style>
